export const getHandloomClusterList = state => {
    return state.list
}

export const getHandloomClusterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/handloomCluster/getters.js